export default __webpack_public_path__ + "static/media/ZK840.4961c3c7.pdf";